module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/discover-d28ccfbe9b48ca1df092f03e277d2f1e.svg";